import { mq, styled } from "../utils";
import { color, space, typography } from 'styled-system';
var Heading = function (key) {
    return styled(key)(function (_a) {
        var headings = _a.theme.components.headings;
        return mq(headings[key]);
    }, typography, color, space);
};
export default {
    Heading1: Heading('h1'),
    Heading2: Heading('h2'),
    Heading3: Heading('h3'),
    Heading4: Heading('h4'),
    Heading5: Heading('h5'),
    Heading6: Heading('h6'),
};
//# sourceMappingURL=Heading.js.map